import { useTranslation } from "react-i18next";
import { ArrowDown } from "@phosphor-icons/react";
import { FilmReel, Globe, FileText } from "@phosphor-icons/react";

export const ProgrammeHero = () => {
  const { t } = useTranslation();

  const stats = [
    {
      icon: FilmReel,
      value: t("programme.hero.stat1_value"),
      label: t("programme.hero.stat1_label"),
    },
    {
      icon: Globe,
      value: t("programme.hero.stat2_value"),
      label: t("programme.hero.stat2_label"),
    },
    {
      icon: FileText,
      value: t("programme.hero.stat3_value"),
      label: t("programme.hero.stat3_label"),
    },
  ];

  return (
    <section
      data-testid="programme-hero"
      className="relative flex items-center justify-center min-h-screen pt-32 pb-24 overflow-hidden"
    >
      <div className="absolute inset-0 adonis-grid-bg [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_75%)]" />
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[520px] w-[820px] opacity-30 blur-3xl pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center, #7B61FF 0%, transparent 60%), radial-gradient(circle at 70% 50%, #4DD0E1 0%, transparent 60%)",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-[1] text-slate-900">
          {t("programme.hero.title_a")}
          <br />
          <span className="adonis-gradient-text">
            {t("programme.hero.title_b")}
          </span>
        </h1>

        <p className="mt-10 mx-auto max-w-2xl text-lg leading-relaxed text-slate-600">
          {t("programme.hero.subtitle")}
        </p>

        <div className="mt-12 grid grid-cols-3 gap-3 sm:gap-4 max-w-2xl mx-auto">
          {stats.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`programme-hero-stat-${i}`}
                className="rounded-2xl border border-slate-200 bg-white/80 backdrop-blur-sm px-4 py-4 text-left"
              >
                <Icon size={18} weight="light" className="text-slate-400" />
                <p className="mt-3 font-heading text-xl md:text-2xl font-bold tracking-tight text-slate-900">
                  {s.value}
                </p>
                <p className="mt-0.5 text-[10px] md:text-xs uppercase tracking-wider text-slate-500 font-medium">
                  {s.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 text-slate-400">
        <ArrowDown
          size={16}
          weight="bold"
          className="animate-bounce [animation-duration:2s]"
        />
        <span className="text-[10px] font-bold uppercase tracking-[0.3em]">
          {t("programme.hero.scroll")}
        </span>
      </div>
    </section>
  );
};

export default ProgrammeHero;
